import { render, staticRenderFns } from "./SourceForm.vue?vue&type=template&id=b37af98a&scoped=true&"
import script from "./SourceForm.vue?vue&type=script&lang=js&"
export * from "./SourceForm.vue?vue&type=script&lang=js&"
import style0 from "./SourceForm.vue?vue&type=style&index=0&id=b37af98a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37af98a",
  null
  
)

export default component.exports